import { useMutation } from '@tanstack/react-query';
import Resources from '../../../helpers/resources';
import { getValueFromUrl } from '../../../helpers/utils';

export const useSingleQuestion = () => {
  const id = getValueFromUrl('girlId');
  const locale = getValueFromUrl('locale');

  const getQuestion = async () => {
    const question = await Resources.previewSingleQuestion
      .get({ id, locale })
      .send();

    return question;
  };

  return { ...useMutation({ mutationFn: getQuestion }) };
};
